import TextInput from "../../../../components/inputs/text";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import MaskInput from "../../../../components/inputs/mask";
import Loading from "../../../../components/loading";
import { ToastContainer } from "react-toastify";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import SelectInput from "../../../../components/inputs/select";
import CheckboxInput from "../../../../components/inputs/check";
import { BtnCustom } from "../../../../components/button/button";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import cloudError from "../../../../assets/cloud-error.webp";
import { useState } from "react";
import UploadPhotoV2 from "../../../../components/uploading/uploadingPhotoV2";

const FormStore = () => {
	const {
		//hooks
		handleFetchAddress,
		handleSelectedState,
		handleOnSubmit,

		//useForm
		setValue,
		setFocus,
		register,
		handleSubmit,
		control,
		errors,
		isSubmitting,
		watch,

		//States
		shouldOpenForm,
		citiesData,
		brazilStates,

		//watch
		url_logo,
		url_background,
		id_empresa,

		//Loading
		cepIsSubmitting,
		loading,
		loadingCities,

		//vars
		isUpdatedImage,
		setIsUpdatedImage,

		//tab
		valueTab,
		handleChangeTab,
	} = IndexHook();

	//#region Upload da imagem

	// useEffect(() => {
	// }, [isUpdatedImage]);

	const handleOpenUploadComponent = (e) => {
		e.preventDefault();

		const event = new CustomEvent("openUpload");
		window.dispatchEvent(event);
	};

	const onChangeUpload = (data) => {
		setIsUpdatedImage(true);
		setValue("url_logo", data.url);
	};

	const handleOpenUploadBackGround = (e) => {
		e.preventDefault();

		const event = new CustomEvent("photoBackGround");
		window.dispatchEvent(event);
	};

	const onChangeUploadBackGround = (data) => {
		setIsUpdatedBackGround(true);
		setValue("url_background", data.url);
	};
	const [isUpdatedBackGround, setIsUpdatedBackGround] = useState(false);
	//#endregion

	const reloadPage = () => {
		window.location.reload();
	};

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<>
					<ToastContainer />
					{shouldOpenForm ? (
						<div className="container-forms">
							<form
								onSubmit={handleSubmit(
									handleOnSubmit,
									// handleOnError
								)}
								className="form"
								autoComplete="off"
							>
								<div className="flex flex-grow flex-col overflow-y-auto">
									<TabContext value={valueTab} className="">
										<Box>
											<TabList onChange={handleChangeTab}>
												<Tab
													label="Dados da Empresa"
													value="0"
													sx={{
														fontSize: "0.775rem",
													}}
												/>
												<Tab
													label="Logo da empresa"
													value="1"
													sx={{
														fontSize: "0.775rem",
													}}
												/>
												<Tab
													label="Catálogo"
													value="2"
													sx={{
														fontSize: "0.775rem",
													}}
												/>
											</TabList>
										</Box>

										<main className="">
											<TabPanel value="0">
												<div className="row">
													<TextInput
														label="Nome da Empresa"
														id="nome"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														autoFocus={true}
														className="col-12 col-lg-6"
													/>
													<TextInput
														label="Nome Fantasia"
														id="fantasia"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-lg-6"
													/>
													<MaskInput
														label="Cep"
														name="cep"
														control={control}
														errors={errors}
														format="#####-###"
														className="col-4 col-sm-4 col-lg-2"
														onKeyDown={libForm.EnterTab}
													/>
													<div className="col-8 d-flex align-items-center">
														<BtnCustom
															className="btn btn-sm btn-outline-primary btn-cep"
															onKeyDown={libForm.EnterTab}
															onClick={(e) => handleFetchAddress()}
															text={
																cepIsSubmitting
																	? "Buscando..."
																	: "Buscar endereço por CEP"
															}
														/>
													</div>
													<TextInput
														label="Endereço"
														id="rua"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-sm-8 col-lg-5"
													/>
													<TextInput
														label="Número"
														id="numero"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-sm-4 col-lg-2"
													/>
													<TextInput
														label="Complemento"
														id="complemento"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-sm-8 col-lg-2"
													/>
													<TextInput
														label="Bairro"
														id="bairro"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-sm-6 col-lg-3"
													/>
													<SelectInput
														label="Estado"
														id="uf"
														labelSelect="nome"
														control={control}
														errors={errors}
														data={brazilStates}
														setValue={setValue}
														onKeyDown={libForm.EnterTab}
														handleSelect={handleSelectedState}
														loading={loadingCities}
														className="col-12 col-sm-6 col-lg-4"
													/>
													<SelectInput
														label="Cidade"
														id="id_cidade"
														labelSelect="nome"
														control={control}
														errors={errors}
														data={citiesData}
														setValue={setValue}
														onKeyDown={libForm.EnterTab}
														loading={loadingCities}
														className="col-12 col-sm-6 col-lg-4"
													/>
													<MaskInput
														label="Celular"
														name="telefone_1"
														control={control}
														errors={errors}
														required={false}
														format="(##)#####-####"
														className="col-6 col-sm-3 col-lg-2"
														onKeyDown={libForm.EnterTab}
														setFocus={setFocus}
													/>
													<MaskInput
														label="Telefone"
														name="telefone_2"
														control={control}
														errors={errors}
														format="(##)#####-####"
														className="col-6 col-sm-3 col-lg-2"
														onKeyDown={libForm.EnterTab}
													/>
													<TextInput
														label="E-mail"
														id="email"
														placeholder=""
														register={register}
														errors={errors}
														onKeyDown={libForm.EnterTab}
														className="col-12 col-sm-6 col-lg-4"
													/>
													<TextInput
														label="Observações"
														id="obs"
														placeholder=""
														register={register}
														errors={errors}
														className="col-12 col-sm-12 col-lg-8"
													/>
												</div>
											</TabPanel>
											<TabPanel value="1">
												<div className="row overflow-x-auto">
													<div className="col-12 col-sm-12 col-lg-12">
														<div>
															<img
																src={url_background}
																alt=""
																className="object-cover shadow-lg "
															/>
														</div>
														<button
															className="btn btn-sm btn-outline-primary mt-3"
															onClick={handleOpenUploadBackGround}
														>
															Escolher imagem fundo
														</button>

														{isUpdatedImage && (
															<span className="flex text-red-500 text-bold justify-center">
																Clique em salvar para confirmar alteração
															</span>
														)}
													</div>
													<div className="flex flex-col items-start justify-center mt-3 col-12 col-sm-12 col-lg-12">
														<div>
															<img
																src={url_logo}
																alt=""
																className="object-cover shadow-lg  max-h-52"
															/>
														</div>
														<button
															className="btn btn-sm btn-outline-primary mt-3 "
															onClick={handleOpenUploadComponent}
														>
															Escolher logo
														</button>

														{isUpdatedImage && (
															<span className="flex text-red-500 text-bold justify-center">
																Clique em salvar para confirmar alteração
															</span>
														)}
													</div>
												</div>
											</TabPanel>
											<TabPanel value="2">
												<div className="row pb-4">
													{/* Configurações Gerais */}
													<div className="col-12 mb-4">
														<div className="border-b pb-2 mb-3">
															<h5 className="text-lg font-semibold text-gray-800 mb-0">
																Aparência e Entregas
															</h5>
															<p className="text-sm text-gray-500 mb-0">
																Defina como seu catálogo online será visto e quais
																opções de entrega estarão disponíveis.
															</p>
														</div>

														<div className="row">
															<SelectInput
																label="Tema / Cores do Catálogo"
																id="theme"
																labelSelect="nome"
																control={control}
																errors={errors}
																data={[
																	{ theme: "red", nome: "Vermelho" },
																	{ theme: "blue", nome: "Azul" },
																	{ theme: "dark", nome: "Escuro" },
																]}
																setValue={setValue}
																onKeyDown={libForm.EnterTab}
																className="col-12 col-sm-6 col-md-4 mb-3"
															/>
														</div>

														<div className="row mt-2">
															<div className="col-12 d-flex flex-wrap gap-3">
																<div
																	className="p-3 border rounded-lg bg-gray-50 flex-grow-1"
																	style={{ minWidth: "250px" }}
																>
																	<CheckboxInput
																		label="Entrega via Transportadora"
																		id="entrega_transportadora"
																		register={register}
																		errors={errors}
																		onKeyDown={libForm.EnterTab}
																	/>
																	<p className="text-xs text-gray-500 mt-1 mb-0 ms-4 ps-2">
																		Permite o cálculo automático de frete usando
																		CEP.
																	</p>
																</div>

																<div
																	className="p-3 border rounded-lg bg-gray-50 flex-grow-1"
																	style={{ minWidth: "250px" }}
																>
																	<CheckboxInput
																		label="Entrega Local / Delivery"
																		id="entrega_local"
																		register={register}
																		errors={errors}
																		onKeyDown={libForm.EnterTab}
																	/>
																	<p className="text-xs text-gray-500 mt-1 mb-0 ms-4 ps-2">
																		Ideal para envios próprios ou motoboys na sua
																		região.
																	</p>
																</div>

																<div
																	className="p-3 border rounded-lg bg-gray-50 flex-grow-1"
																	style={{ minWidth: "250px" }}
																>
																	<CheckboxInput
																		label="Venda com Complementos"
																		id="complementos"
																		register={register}
																		errors={errors}
																		onKeyDown={libForm.EnterTab}
																	/>
																	<p className="text-xs text-gray-500 mt-1 mb-0 ms-4 ps-2">
																		Útil para hamburguerias e lanches (ex: +Bacon,
																		+Molho).
																	</p>
																</div>

																<div
																	className="p-3 border rounded-lg bg-gray-50 flex-grow-1"
																	style={{ minWidth: "250px" }}
																>
																	<CheckboxInput
																		label="Validar Estoque"
																		id="validar_estoque"
																		register={register}
																		errors={errors}
																		onKeyDown={libForm.EnterTab}
																	/>
																	<p className="text-xs text-gray-500 mt-1 mb-0 ms-4 ps-2">
																		Bloqueia a venda de produtos sem estoque
																		disponível.
																	</p>
																</div>
															</div>
														</div>
													</div>

													{/* Seção SEO */}
													<div className="col-12 mt-4">
														<div className="border-b pb-2 mb-3">
															<h5 className="text-lg font-semibold text-gray-800 mb-0">
																Como ser encontrado no Google (SEO)
															</h5>
															<p className="text-sm text-gray-500 mb-0">
																Atraia mais clientes configurando textos atrativos para
																quem pesquisar pelo seu negócio na internet.
															</p>
														</div>

														<div className="bg-blue-50 border border-blue-300 rounded-lg p-3 mb-4 d-flex align-items-start gap-3 shadow-sm">
															<svg
																className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1"
																fill="none"
																stroke="currentColor"
																viewBox="0 0 24 24"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	strokeLinecap="round"
																	strokeLinejoin="round"
																	strokeWidth="2"
																	d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
																></path>
															</svg>
															<div>
																<h6 className="text-sm font-bold text-blue-800 mb-1">
																	Entenda como isso funciona
																</h6>
																<p className="text-sm text-blue-700 mb-0">
																	Você já buscou uma empresa no Google e viu aquele
																	link grande, seguido por um texto explicativo abaixo
																	dele? Isso é o SEO! Capriche nas palavras-chave no
																	formulário abaixo, elas ajudam as pessoas a sentirem
																	confiança de clicar para entrar em seu catálogo.
																</p>
															</div>
														</div>

														<div className="row">
															<div className="col-12 col-md-6 mb-3">
																<TextInput
																	label="Título da Loja no Buscador"
																	id="titulo_seo"
																	placeholder="Ex: Minha Loja - As melhores roupas da cidade"
																	register={register}
																	errors={errors}
																	onKeyDown={libForm.EnterTab}
																	className="w-100"
																/>
																<small className="text-gray-500 d-block mt-1">
																	Exibido nos links principais. Recomendamos usar até
																	60 caracteres.
																</small>
															</div>

															<div className="col-12 mb-3">
																<TextInput
																	label="Resumo/Descrição no Buscador"
																	id="descricao_seo"
																	placeholder="Ex: Compre roupas e acessórios com os melhores preços. Entrega rápida para toda a cidade!"
																	register={register}
																	errors={errors}
																	onKeyDown={libForm.EnterTab}
																	className="w-100"
																/>
																<small className="text-gray-500 d-block mt-1">
																	Explicite o que sua loja vende e seus grandes
																	diferenciais (até 160 caracteres).
																</small>
															</div>
														</div>

														{/* Preview Card Google */}
														<div className="mt-3 border border-gray-200 rounded p-4 bg-white shadow-sm hover:shadow-md transition-shadow duration-200 cursor-default">
															<h6 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">
																Simulação: Como a sua loja deve aparecer no Google
															</h6>
															<div className="mb-0">
																<span className="text-sm text-green-700 font-medium">
																	https://seucatalogo.com.br
																</span>
															</div>
															<h3 className="text-xl text-blue-700 hover:underline cursor-pointer mb-1 text-truncate font-medium">
																{watch("titulo_seo") ||
																	watch("nome") ||
																	"Nome da Sua Loja Aqui"}
															</h3>
															<p
																className="text-sm text-gray-600 mb-0 leading-snug"
																style={{
																	display: "-webkit-box",
																	WebkitLineClamp: 2,
																	WebkitBoxOrient: "vertical",
																	overflow: "hidden",
																}}
															>
																{watch("descricao_seo") ||
																	"A descrição principal e mais comercial do seu negócio aparecerá aqui! Aproveite para listar seus produtos, vantagens, agilidade da entrega ou as suas promoções para atrair os clientes do Google até o site."}
															</p>
														</div>
													</div>
												</div>
											</TabPanel>
										</main>
									</TabContext>
								</div>
								<footer>
									<BtnSubmit isSubmitting={isSubmitting} />
								</footer>
							</form>
						</div>
					) : (
						<div className="flex flex-col justify-center items-center h-52 mt-3">
							<img
								src={cloudError}
								alt="Servidor não encontrado"
								className="w-52 h-40 bg-cover bg-center"
							/>
							<h1 className="text-sm">Verifique a conexão com internet e tente novamente</h1>
							<BtnCustom
								text={"Tentar Novamente"}
								className={"mt-4 btn btn-sm btn-primary"}
								onClick={reloadPage}
							/>
						</div>
					)}
				</>
			)}

			{/* <UploadPhotoV1
				setIsUpdatedImage={setIsUpdatedImage}
				onChange={onChangeUpload}
				nameImg={"logo"}
				type="logo"
				// setValue={setValue}
				// idPhoto={id_produto}
			/> */}

			<UploadPhotoV2
				onChange={onChangeUploadBackGround}
				nameImg={"back"}
				type="background"
				ident="photoBackGround"
				id={id_empresa}
			/>
			<UploadPhotoV2
				onChange={onChangeUpload}
				nameImg={"logo"}
				type="logo"
				ident="openUpload"
				id={id_empresa}

				// setValue={setValue}
				// idPhoto={id_produto}
			/>
		</>
	);
};

export default FormStore;
